/**
 * An exception to skip execution of the experiment.
 *
 * This class has been extended without using ES6 so that "instanceof" works as intended.
 *
 * See:
 * http://stackoverflow.com/questions/33870684/why-doesnt-instanceof-work-on-instances-of-error-subclasses-under-babel-node
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
 */

function WithdrawExperimentException(message) {
  this.name = 'WithdrawExperimentException';
  this.message = message || 'The experiment was withdrawn and will not run.';
  this.stack = (new Error()).stack;
}

WithdrawExperimentException.prototype = Object.create(Error.prototype);
WithdrawExperimentException.prototype.constructor = WithdrawExperimentException;

export default WithdrawExperimentException;


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/withdraw-experiment-exception.js